<div class="modal-dialog-wrapper" appDialogSelectable appDialogKeyboardEnabled [appDialogMinimizable]="MinimizableDialogType.CaseDocument">
  <mat-dialog-content (cdkDragStarted)="dialogBoundryService.handleDragStart($event)" (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">
          {{ 'case-document-modal-title' | translate }}
        </div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" />
          </div>
        </div>
      </div>
      <div class="task-message-attachment-container">
        <div class="m-0">
          <app-task-message-attachment [caseId]="data.caseId" [attachment]="data.attachment" [disabled]="data.disabled">
          </app-task-message-attachment>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
